import script from "./ListingBlockLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListingBlockLayout.vue?vue&type=script&setup=true&lang=ts"

import "./ListingBlockLayout.vue?vue&type=style&index=0&id=510717f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-510717f0"]])

export default __exports__